<i18n locale="en">
{
  "label": "Navigation logo palette",
  "options": {
    "light": "Light",
    "dark": "Dark",
    "standard": "Standard"
  }
}
</i18n>

<template>
  <OwnInputContainer :label="t('label')">
    <OwnSelect
      :model-value="transparentLogoPalette"
      :options="paletteOptions"
      @update:model-value="changePalette"
    />
  </OwnInputContainer>
</template>

<script>
import set from 'lodash/set'
import { useI18n } from 'vue-i18n'
import { mapActions, mapGetters } from 'vuex'

import { useApplicationScope } from '@/core/store'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnSelect } from '@/ui/OwnSelect'

export default {
  name: 'NavigationLogoPaletteEditor',
  components: {
    OwnInputContainer,
    OwnSelect,
  },

  setup() {
    const { t } = useI18n()
    const { activeBrandId } = useApplicationScope()

    return { activeBrandId, t }
  },
  computed: {
    ...mapGetters({
      currentResource: 'websiteBuilder/currentResource',
    }),
    paletteOptions() {
      return [
        { label: this.t('options.standard'), value: 'standard' },
        { label: this.t('options.light'), value: 'light' },
        { label: this.t('options.dark'), value: 'dark' },
      ]
    },
    transparentLogoPalette() {
      return (
        this.currentResource?.funnel?.navigation?.transparentLogoPalette ??
        'dark'
      )
    },
  },
  methods: {
    ...mapActions({
      updateResource: 'websiteBuilder/updateResource',
    }),
    changePalette(value) {
      this.updateResource(
        set({}, 'funnel.navigation.transparentLogoPalette', value)
      )
    },
  },
}
</script>

<style lang="scss" scoped></style>
